import React, {useContext, useEffect, useState} from 'react';
import InputForm from "../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import locationService from "../../../../../services/web/location-service.js";
import {PointLayerContext} from "../point-layer-context.jsx";
import {getCities, getNeighborhoods, getStreets} from "../../../../../utils/location-utils.js";
import optionsUtils from "../../../../../utils/options-utils.js";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import Button from "../../../../../components/button/button.jsx"
import {FaCheck, FaPlus, FaTrash} from "react-icons/fa";
import {useMapsLibrary} from "@vis.gl/react-google-maps";
import projectUtils from "../../../../../utils/project-utils.js";

const PanelPointDetails = ({setShowPointPanel, pointSelected, initialData, map, setItemsToRemove, showPointPanel}) => {
    const geocoding = useMapsLibrary('geocoding');
    const {setIsLoading, setPoints} = useContext(PointLayerContext)

    const [dataPoint, setDataPoint] = useState(initialData)

    useEffect(() => {
        handleGeoCoder()
    }, [dataPoint]);

    useEffect(() => {
        if (pointSelected?.data) {
            setDataPoint(pointSelected.data)
        }
    }, [pointSelected]);

    const handleGeoCoder = () => {
        const { street, number, neighborhood, city } = dataPoint;

        const parts = [];

        if (street) parts.push(street);
        if (number) parts.push(number);
        if (neighborhood) parts.push(`- ${neighborhood}`);
        if (city) parts.push(`- ${city}`);

        const address = parts.join(', ');

        if (!address) return;

        const geocoder = new geocoding.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status !== 'OK') return;

            const location = results[0].geometry.location;
            pointSelected.marker.setPosition(location);
            map.setCenter(location);
        });
    }

    const {data: streets, isLoading: isLoadingStreets} = useQuery({
        queryFn: async () => locationService.getStreets("").then((data) => data.map(d => ({value: d.id, label: d.text}))),
        queryKey: ['streets'],
        enabled: showPointPanel
    });

    const {data: neighborhoods, isLoading: isLoadingNeighborhoods} = useQuery({
        queryFn: async () => locationService.getNeighborhoods("").then((data) => data.map(d => ({value: d.id, label: d.text}))),
        queryKey: ['neighborhoods'],
        enabled: showPointPanel
    });

    useEffect(() => {
        setIsLoading(isLoadingStreets || isLoadingNeighborhoods)
    }, [isLoadingStreets, isLoadingNeighborhoods]);

    const onChange = ({target: {value, id}}) => setDataPoint(prevState => ({...prevState, [id]: value}))

    const save = () => {
        if (!dataPoint.name) {
            projectUtils.swalErrorMessage('', "O campo \"Nome\" é obrigatório.", 'Ok');
            return
        }

        setPoints(prevState => prevState.map(p => p.id === pointSelected.id ? { ...p, data: dataPoint } : p));

        setShowPointPanel(false)
        setDataPoint(initialData)
    }

    const remove = () => {
        pointSelected.marker.setMap(null);
        setShowPointPanel(false)
        setPoints(prevState => prevState.filter(p => p.id !== pointSelected.id));
        if (typeof pointSelected.id === "number") setItemsToRemove(prevState => ([...prevState, pointSelected.id]))
    }

    return (
        <>
            <div className={"h-[calc(100vh-120px)]"}>
                <div className={"mb-3"}>
                    <p className={"text-xs font-bold"}>Propriedades do ponto</p>
                </div>
                <div className="grid grid-cols-12 gap-4 mb-3">
                    <div className="col-span-12">
                        <InputForm id="name" value={dataPoint?.name} label="Nome *" onChange={onChange}/>
                    </div>

                    <SelectComponent
                        classNameWrapper={"col-span-9"}
                        loadOptions={getStreets}
                        value={optionsUtils.getValue(dataPoint?.street)}
                        isAsync={true}
                        label="Logradouro"
                        onChange={(selected) => setDataPoint(prevState => ({...prevState, street: selected?.value || ""}))}
                        cacheOptions
                        defaultOptions={[]}
                    />

                    <div className="col-span-3">
                        <InputForm id="number" value={dataPoint?.number} label="Número" onChange={onChange}/>
                    </div>

                    <SelectComponent
                        classNameWrapper={"col-span-6"}
                        loadOptions={getNeighborhoods}
                        value={optionsUtils.getValue(dataPoint?.neighborhood)}
                        isAsync={true}
                        label="Bairro"
                        onChange={(selected) => setDataPoint(prevState => ({...prevState, neighborhood: selected?.value || ""}))}
                        cacheOptions
                        defaultOptions={[]}
                    />

                    <SelectComponent
                        classNameWrapper={"col-span-6"}
                        loadOptions={getCities}
                        value={optionsUtils.getValue(dataPoint?.city)}
                        isAsync={true}
                        label="Município - UF"
                        onChange={(selected) => setDataPoint(prevState => ({...prevState, city: selected?.value || ""}))}
                        cacheOptions
                        defaultOptions={[]}
                    />

                    <InputTextarea className={"col-span-12"} textAreaClass={"h-20"} label="Observação" value={dataPoint?.observation} id={"observation"} onChange={onChange} />
                </div>
            </div>
            <div className={"flex justify-end gap-3"}>
                <Button target={"danger"} onClick={remove}>
                    Remover
                </Button>
                <Button target={"primary-outline"} onClick={save}>
                    {pointSelected?.data?.name
                        ? <><FaCheck /> Confirmar</>
                        : <><FaPlus /> Adicionar</>}
                </Button>
            </div>
        </>
    );
};

export default PanelPointDetails;